import { render, staticRenderFns } from "./owner_header.vue?vue&type=template&id=55f58030&scoped=true"
import script from "./owner_header.vue?vue&type=script&lang=js"
export * from "./owner_header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f58030",
  null
  
)

export default component.exports